import React from 'react'

import SpinnerStyles from './Spinner.module.scss'

const Spinner = () => {
    return (
        <div className={SpinnerStyles.spinner}>
        </div>
    )
}

export default Spinner
